import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Modifier {
  id: number | null;
  warehouseProductId: number | null;
  warehouseProductUnitId: string;
  grossPriceDifference: number | null;
  isActive: boolean;
}

interface UnitComponent {
  id: number | null;
  warehouseProductId: number | null;
  warehouseProductUnitId: string;
  quantity: number | null;
  modifiers: Modifier[];
}

interface DepositFee {
  depositFeePrice: number | null;
  hasDepositFee: string | null;
  depositFeeCount: number | null;
}

interface Unit {
  id: number | null;
  unit: number | null;
  unitName: string;
  quantity: number | null;
  defaultPrice: number | null;
  bulk: boolean;
  depositFeeList: DepositFee[];
  hasRecipe: boolean | null;
  unitComponents: UnitComponent[];
  quickrActive: boolean;
  quickrGrossPrice: number | null;
  barcode: string | null;
}

interface ProductDetails {
  id: number | null;
  name: string;
  mainCategoryId: number | null;
  mainCategoryName: string | null;
  subCategoryId: number | null;
  subCategoryName: string | null;
  customCategory: string | null;
  vatId: number | null;
  isTakeawayAllowed: boolean;
  takeawayVatId: number | null;
}

interface Packaging {
  units: Unit[];
}

interface ProductState {
  details: ProductDetails;
  packaging: Packaging;
}

const initialState: ProductState = {
  details: {
    id: null,
    name: '',
    mainCategoryId: null,
    mainCategoryName: null,
    subCategoryId: null,
    subCategoryName: null,
    customCategory: null,
    vatId: null,
    isTakeawayAllowed: false, 
    takeawayVatId: null,
  },
  packaging: {
    units: [
      {
        id: null,
        unit: null,
        unitName: '',
        quantity: null,
        defaultPrice: null,
        bulk: false, 
        depositFeeList: [
          {
            depositFeePrice: null,
            hasDepositFee: null,
            depositFeeCount: null,
          },
        ],
        hasRecipe: null,
        unitComponents: [
          {
            id: null,
            warehouseProductId: null,
            warehouseProductUnitId: '',
            quantity: null,
            modifiers: [
              {
                id: null,
                warehouseProductId: null,
                warehouseProductUnitId: '',
                grossPriceDifference: null,
                isActive: false, 
              },
            ],
          },
        ],
        quickrActive: false,
        quickrGrossPrice: null,
        barcode: null,
      },
    ],
  },
};


const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setDetails(state, action: PayloadAction<Partial<ProductState['details']>>) {
      state.details = { ...state.details, ...action.payload };
    },
    setPackaging(state, action: PayloadAction<Partial<ProductState['packaging']>>) {
      state.packaging = { ...state.packaging, ...action.payload };
    },
  },
});

export const { setDetails, setPackaging } = productSlice.actions;
export default productSlice.reducer;
